import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1723_7626)">
        <path
          d="M9.66894 6L5.66894 2.33333L5.66895 9M5.66895 13L5.66895 11.3333"
          stroke="black"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66895 6L5.66894 2.33333L5.66894 9M5.66894 13L5.66894 11.3333"
          stroke="black"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66895 6L5.66894 2.33333L5.66894 9M5.66894 13L5.66894 11.3333"
          stroke="black"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1_1723_7626)">
          <path
            d="M9.66797 6.00049L5.66797 2.33382L5.66797 9.00049M5.66797 13.0005L5.66797 11.3338"
            stroke="black"
            strokeOpacity="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1723_7626">
          <rect width="10" height="16" fill="white" transform="translate(0.5)" />
        </clipPath>
        <clipPath id="clip1_1723_7626">
          <rect width="4" height="4.66667" fill="white" transform="translate(5.00098 13.667) rotate(-90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
